import styled from 'styled-components';
import getSpacing from '~/helpers/getSpacing';
import { mq, containerWidth } from '~/styles/grid';
import Container from '~/grid/Container';

const SpacingContainer = styled.div`
  width: 100%;
  display: block;
  ${(props) => getSpacing(props.spacing, 'py')};
`;

const Line = styled.hr`
  margin: 0 auto;
  border-top: 1px solid
    ${(props) => {
      const { color, spacer } = props.theme;
      return color[spacer.color];
    }};
  max-width: ${containerWidth.xl}px;

  @media (${mq.lgDown}) {
    max-width: ${containerWidth.lg}px;
  }

  @media (${mq.mdDown}) {
    max-width: ${containerWidth.md}px;
  }

  @media (${mq.sm}) {
    max-width: ${containerWidth.sm}px;
  }
`;

/**
 * @param {SpacerProps} props
 * @returns {React.ReactElement} The rendered component
 */
const Spacer = ({ line, spacing, rooted }) => {
  const spacer = (
    <SpacingContainer spacing={spacing}>{line && <Line />}</SpacingContainer>
  );

  return rooted ? <Container>{spacer}</Container> : spacer;
};

export default Spacer;
